import hexOpacity from 'utils/styling/hexOpacity'
import type { HexOpacityMap, DropShadow } from 'types/style'

type BoxShadowEdits = {
  dropShadow?: DropShadow
  boxShadow?: string
  feather?: boolean
  borderThickness?: number
  borderColor?: string
}

const isValidDropShadow = (shadow: DropShadow | undefined) => {
  if (!shadow) return false
  const isObject = typeof shadow === 'object'
  const hasColor = 'color' in shadow
  const hasKeys = Object.keys(shadow).length > 0
  return isObject && hasColor && hasKeys
}

const getDropShadow = (edits: BoxShadowEdits) => {
  if (!isValidDropShadow(edits?.dropShadow)) return edits?.boxShadow
  const {
    xOffset = 0,
    yOffset = 0,
    blur = 0,
    spread = 0,
    color = '',
    opacity = 1,
  } = edits?.dropShadow as DropShadow
  return `${xOffset}px ${yOffset}px ${blur}px ${spread}px ${color}${
    hexOpacity[Math.floor(opacity * 100) as keyof HexOpacityMap] || ''
  }`
}

// Returns border shorthand for image borders, applied via ::after pseudo-element
// in PageImage.styled.js to render above GPU-composited image layers and prevent
// Chromium's print-to-PDF from filling transparent areas with the border color.
export const getImageBorderOutline = (edits: BoxShadowEdits) => {
  const thickness = edits?.borderThickness ?? 0
  if (thickness <= 0 || !edits?.borderColor) return 'none'
  return `${thickness}px solid ${edits.borderColor}`
}

export const getCombinedBoxShadow = (edits: BoxShadowEdits) => {
  const isFeathering = edits?.feather
  if (isFeathering) return 'none'

  return getDropShadow(edits)
}
